import { PublicClientApplication } from "@azure/msal-browser";
import { createBypassMsalInstance, createLoginRequest, createMsalConfig, workerScopes } from "@drs-ops/auth/frontend";

// Dev-bypass is driven by Vite's MODE — "development" locally, "staging" / "production" on build.
export const IS_DEV_BYPASS = import.meta.env.MODE === "development";

const clientId = (import.meta.env.VITE_MSAL_CLIENT_ID ?? "") as string;
const tenantId = (import.meta.env.VITE_MSAL_TENANT_ID ?? "common") as string;

export const msalInstance: PublicClientApplication = IS_DEV_BYPASS
  ? createBypassMsalInstance()
  : new PublicClientApplication(createMsalConfig({ clientId, tenantId }));

export const loginRequest = createLoginRequest(clientId);
export const workerTokenScopes = workerScopes(clientId);
